export default "__VITE_ASSET__BsK2hwI___"